<template>
  <div class="reset-password">
    <el-form :model="form" status-icon :rules="rules" ref="form" label-width="200px" class="demo-ruleForm">
      <h2>{{ $t('default.updatePassword') }}</h2>
      <el-form-item :label="$t('default.newPassword')" prop="pass">
        <el-input type="password" v-model="form.pass" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('default.confrimPassword')" prop="checkPass">
        <el-input type="password" v-model="form.checkPass" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">{{$t('default.submit')}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import md5 from 'js-md5'
export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      form: {
        pass: '',
        checkPass: ''
      },
      rules: {
        pass: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async putPass () {
      const doc = {
        password: md5(this.form.pass)
      }
      try {
        await this.$store.dispatch('resetPassword', doc)
        this.$notify({
          title: '密码修改成功',
          type: 'success'
        })
      } catch (e) {
        console.log(e)
        this.$notify({
          title: '操作失败',
          type: 'error'
        })
        throw e
      }
    },
    submitForm () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.$confirm('确认修改密码？')
            .then(_ => {
              this.putPass()
            })
            .catch(_ => {})
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style>
.reset-password {
  width: 500px;
  padding: 50px 50px 50px;
  margin: 100px auto;
  box-shadow: 0 16px 28px 0 rgba(0, 0, 0, 0.22), 0 25px 55px 0 rgba(0, 0, 0, 0.21);
  border: 1px solid #DFDFDF;
}
.reset-password  .el-button {
  width: 100%
}
</style>
